import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["src"]

import get from 'lodash/get';
import { watch, computed, ref, useAttrs } from 'vue';
import { Http } from '@/shared/api/api';
import { useProfileImgsStore } from '@/stores/profileImg';
import ProfilePop from '@/components/ProfilePop.vue';
import BasePopup from '@/components/BasePopup.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'DefaultProfileImage',
  props: {
  profileForm: {
    type: Object,
    default: () => null,
  },
  ableShowProfile: {
    type: Boolean,
    default: () => true,
  },
  size: {
    type: Number,
    default: 36,
  },
},
  setup(__props) {

const props = __props;

const attrs = useAttrs();

const profileImgsModule = useProfileImgsStore();
const selectedFile = computed(() =>
  props.profileForm?.profileFileIdx
    ? profileImgsModule.cachedImg[props.profileForm.profileFileIdx]
    : null,
);

const createObjectURL = (file: File | null) => {
  if (!file) return '';

  try {
    if (!(file instanceof Blob)) {
      throw new Error('Invalid file type');
    }

    return URL.createObjectURL(file);
  } catch (error) {
    console.error('Error creating object URL:', error);
    return '';
  }
};

const getProfileImg = async () => {
  if (
    !props.profileForm?.profileFileIdx ||
    profileImgsModule.cachedIdx.includes(props.profileForm.profileFileIdx.toString())
  )
    return;

  profileImgsModule.cachedImg[props.profileForm.profileFileIdx] = null;

  const res = await Http.api().get(
    `/file?fileIdx=${props.profileForm?.profileFileIdx}`,
    {},
    'blob',
  );

  profileImgsModule.cachedImg[props.profileForm.profileFileIdx] = res.data;
};

const isShowProfile = ref(false);

watch(
  () => props.profileForm,
  () => {
    getProfileImg();
  },
  { immediate: true },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "profile_image--hover",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (__props.ableShowProfile ? (isShowProfile.value = true) : _unref(attrs)?.onClick()), ["stop"]))
    }, [
      (createObjectURL(selectedFile.value))
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: _normalizeClass([
        'rounded-full',
        {
          'hover:opacity-90 cursor-pointer': __props.ableShowProfile,
        },
      ]),
            src: createObjectURL(selectedFile.value),
            style: _normalizeStyle({
        minWidth: `${__props.size}px`,
        width: `${__props.size}px`,
        height: `${__props.size}px`,
      })
          }, null, 14, _hoisted_1))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "rounded-full grid place-items-center",
            style: _normalizeStyle({
        backgroundColor: __props.profileForm?.colorCode || '#00D696',
        borderColor: __props.profileForm?.colorCode || '#00D696',
        width: `${__props.size}px`,
        height: `${__props.size}px`,
      })
          }, [
            _createElementVNode("p", {
              class: "text-white",
              style: _normalizeStyle({
          fontSize: `${__props.size / 3}px`,
        })
            }, _toDisplayString(_unref(get)(__props.profileForm, 'nickname[0]', '')), 5)
          ], 4))
    ]),
    _createVNode(BasePopup, {
      modelValue: isShowProfile.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isShowProfile).value = $event)),
      title: "프로필 보기",
      closeText: "별점주기",
      class: "profile-popup",
      showFooter: false,
      showHeader: false
    }, {
      default: _withCtx(() => [
        (isShowProfile.value)
          ? (_openBlock(), _createBlock(ProfilePop, {
              key: 0,
              profileForm: __props.profileForm,
              onCloseProfile: _cache[1] || (_cache[1] = ($event: any) => (isShowProfile.value = false))
            }, null, 8, ["profileForm"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})